import { Box } from '@chakra-ui/react';
import React from 'react';
import * as Types from '../../types';

interface ChartBarProps {
  bar: Types.ChartBar;
  dividendHeight: number;
  rewardHeight: number;
  width: number | string;
  borderRadius: number;
  last?: boolean;
  selected: boolean;
}

export const ChartBar: React.FC<ChartBarProps> = ({
  borderRadius,
  dividendHeight,
  rewardHeight,
  width,
  last,
  selected,
}) => {
  const _dividendHeight = dividendHeight < 10 ? 10 : dividendHeight;
  const _rewardHeight = rewardHeight < 10 ? 10 : rewardHeight;

  return (
    <Box cursor="pointer" flexDirection="column" justifyContent="flex-end" opacity={selected ? 1 : 0.5} w={width}>
      <Box>
        <Box style={{ flexDirection: 'column', justifyContent: 'flex-end' }}>
          {/* Reward Data Bar */}
          {!last && (
            <Box>
              <Box
                backgroundColor="green.400"
                borderTopLeftRadius={borderRadius}
                borderTopRightRadius={borderRadius}
                height={`${_rewardHeight}px`}
                minHeight={borderRadius}
                mb="1px"></Box>
            </Box>
          )}
          {/* Amount Bar */}
          <Box>
            <Box
              backgroundImage={last ? '/assets/gfx/empty-dividend-bar.svg' : undefined}
              borderBottomLeftRadius={borderRadius}
              backgroundSize={last ? 'cover' : undefined}
              background={last ? undefined : 'linear-gradient(#05346C 0%, #AEC0D4 100%)'}
              borderBottomRightRadius={borderRadius}
              borderTopLeftRadius={_rewardHeight ? 0 : borderRadius}
              borderTopRightRadius={_rewardHeight ? 0 : borderRadius}
              height={_dividendHeight}
              minHeight={borderRadius}></Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
